/* Default collection page (sections/ls-collection-grid.liquid): applies Shopify storefront filters without a
   page reload by re-rendering the section via ?section_id=, loads further pages in place, popovers on
   desktop, bottom sheet on phones. Without this script the form is a plain GET form and the pager a link. */
(() => {
  const phone = matchMedia('(max-width: 749px)');
  const done = new WeakSet();

  function init(root) {
    if (done.has(root)) return;
    done.add(root);
    const id = root.dataset.section;
    let cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-lcg-config]').textContent); } catch (e) {}
    let ctrl = null, timer = 0, loading = false, io = null;
    const $ = (sel) => root.querySelector(sel);
    const form = () => $('[data-lcg-form]');

    const withSection = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', id);
      return u.toString();
    };
    const cleanUrl = (url) => {
      const u = new URL(url, location.origin);
      u.searchParams.delete('section_id');
      u.searchParams.delete('page');
      return u.pathname + (u.search || '');
    };

    function formUrl() {
      const f = form();
      const params = new URLSearchParams();
      for (const [k, v] of new FormData(f)) {
        if (v === '' && /\.(gte|lte)$/.test(k)) continue;
        if (k === 'sort_by' && v === (f.querySelector('[data-lcg-sort]') || {}).dataset?.default) continue;
        params.append(k, v);
      }
      const q = params.toString();
      return f.getAttribute('action') + (q ? '?' + q : '');
    }

    async function render(url, push = true) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      const status = $('[data-lcg-status]');
      if (status && cfg.loading) status.textContent = cfg.loading;
      try {
        const res = await fetch(withSection(url), { signal: ctrl.signal, credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-lcg]');
        if (!fresh) throw new Error('no section');
        swap(fresh);
        if (push) history.pushState({ lcg: id }, '', cleanUrl(url));
      } catch (e) {
        if (e.name === 'AbortError') return;
        location.href = cleanUrl(url);
      } finally {
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
      }
    }

    function swap(fresh) {
      const open = root.querySelector('.lcg-pop[open]');
      const openKey = open && open.dataset.lcgPop;
      const more = form() && form().classList.contains('is-more');
      const active = document.activeElement;
      const focusId = active && root.contains(active) && active.id;
      const focusPop = !focusId && active && active.closest && active.closest('.lcg-pop') && active.closest('.lcg-pop').dataset.lcgPop;
      const list = $('.lcg-facets__list');
      const scroll = list ? list.scrollTop : 0;
      const finds = {};
      root.querySelectorAll('[data-lcg-find]').forEach((i) => { if (i.value) finds[i.closest('.lcg-pop').dataset.lcgPop] = i.value; });

      root.innerHTML = fresh.innerHTML;

      if (more) setMore(true);
      if (openKey) {
        const p = root.querySelector(`.lcg-pop[data-lcg-pop="${CSS.escape(openKey)}"]`);
        if (p) { p.open = true; align(p); }
      }
      Object.entries(finds).forEach(([k, v]) => {
        const i = root.querySelector(`.lcg-pop[data-lcg-pop="${CSS.escape(k)}"] [data-lcg-find]`);
        if (i) { i.value = v; find(i); }
      });
      const l2 = $('.lcg-facets__list');
      if (l2) l2.scrollTop = scroll;
      let target = focusId && document.getElementById(focusId);
      if (!target && focusPop) target = root.querySelector(`.lcg-pop[data-lcg-pop="${CSS.escape(focusPop)}"] > summary`);
      if (!target && root.classList.contains('is-sheet')) target = $('[data-lcg-sheet-close]');
      if (target) target.focus({ preventScroll: true });
      hydrate();
    }

    function apply(delay = 0) {
      clearTimeout(timer);
      timer = setTimeout(() => render(formUrl()), delay);
    }

    async function loadMore(link, byKeyboard) {
      if (loading) return;
      loading = true;
      link.classList.add('is-busy');
      link.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(withSection(link.href), { credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const grid = $('[data-lcg-grid]');
        const items = doc.querySelectorAll('[data-lcg-grid] > [data-lcg-item]');
        let first = null;
        items.forEach((it) => {
          const node = document.importNode(it, true);
          node.classList.add('is-new');
          grid.appendChild(node);
          if (!first) first = node;
        });
        const pager = doc.querySelector('[data-lcg-pager]');
        if (pager) $('[data-lcg-pager]').replaceWith(document.importNode(pager, true));
        if (byKeyboard && first) {
          const a = first.querySelector('a[href]');
          if (a) a.focus({ preventScroll: false });
        }
        observe();
      } catch (e) {
        link.classList.remove('is-busy');
        link.classList.add('is-error');
        link.removeAttribute('aria-busy');
        delete link.dataset.auto;
        if (cfg.error) link.querySelector('span').textContent = cfg.error;
      } finally {
        loading = false;
      }
    }

    function observe() {
      if (io) io.disconnect();
      const link = $('[data-lcg-next][data-auto]');
      if (!link || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { io.disconnect(); loadMore(link, false); }
      }, { rootMargin: '600px 0px' });
      io.observe(link);
    }

    function setMore(on) {
      const f = form();
      const btn = $('[data-lcg-more]');
      if (!f) return;
      f.classList.toggle('is-more', on);
      if (btn) btn.setAttribute('aria-expanded', on);
    }

    function align(pop) {
      if (phone.matches) return;
      pop.removeAttribute('data-align');
      const panel = pop.querySelector('.lcg-pop__panel');
      if (!panel) return;
      const r = panel.getBoundingClientRect();
      if (r.right > document.documentElement.clientWidth - 12) pop.dataset.align = 'end';
    }

    function closePops(except) {
      root.querySelectorAll('.lcg-pop[open]').forEach((p) => { if (p !== except) p.open = false; });
    }

    function find(input) {
      const pop = input.closest('.lcg-pop');
      const term = input.value.trim().toLowerCase();
      let any = false;
      pop.querySelectorAll('[data-lcg-value]').forEach((li) => {
        const empty = li.querySelector('.is-off') && !li.querySelector('input:checked');
        const match = !term || li.dataset.lcgValue.includes(term);
        li.hidden = !match || (empty && li.dataset.hideEmpty === '1');
        if (!li.hidden) any = true;
      });
      const none = pop.querySelector('[data-lcg-find-none]');
      if (none) none.hidden = any;
    }

    function money(n, sym) {
      return sym + Math.round(n).toLocaleString();
    }

    function presets() {
      const rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
      root.querySelectorAll('[data-lcg-presets]').forEach((box) => {
        if (box.childElementCount) return;
        const max = Number(box.dataset.max) || Infinity;
        const pop = box.closest('.lcg-pop');
        const minI = pop.querySelector(`input[name="${box.dataset.minName}"]`);
        const maxI = pop.querySelector(`input[name="${box.dataset.maxName}"]`);
        const sym = (pop.querySelector('.lcg-price__field i') || {}).textContent || '';
        const nice = (v) => { const x = v * rate; const step = x >= 1000 ? 50 : x >= 100 ? 10 : 5; return Math.max(step, Math.round(x / step) * step); };
        const breaks = box.dataset.lcgPresets.split(',').map((v) => Number(v.trim())).filter((v) => v > 0).map(nice).filter((v) => v < max);
        if (!breaks.length) return;
        const ranges = [];
        breaks.forEach((b, i) => ranges.push([i ? breaks[i - 1] : '', b]));
        ranges.push([breaks[breaks.length - 1], '']);
        ranges.forEach(([lo, hi]) => {
          const label = lo === '' ? (cfg.under || '').replace('[max]', money(hi, sym))
            : hi === '' ? (cfg.over || '').replace('[min]', money(lo, sym))
            : (cfg.range || '').replace('[min]', money(lo, sym)).replace('[max]', money(hi, sym));
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'lcg-preset';
          b.textContent = label;
          b.dataset.min = lo;
          b.dataset.max = hi;
          const on = String(minI.value) === String(lo) && String(maxI.value) === String(hi) && (minI.value || maxI.value);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          box.appendChild(b);
        });
      });
    }

    function hydrate() {
      const chips = $('.lcg-chips');
      const total = Number(chips && chips.dataset.lcgTotalValue) || 0;
      const badge = $('[data-lcg-total]');
      if (badge) { badge.textContent = total; badge.hidden = !total; }
      root.querySelectorAll('[data-lcg-value]').forEach((li) => { if (li.hidden) li.dataset.hideEmpty = '1'; });
      presets();
      observe();
    }

    function sheet(on) {
      root.classList.toggle('is-sheet', on);
      document.documentElement.classList.toggle('lcg-lock', on);
      const btn = $('[data-lcg-sheet-open]');
      if (btn) btn.setAttribute('aria-expanded', on);
      if (on) {
        const c = $('.lcg-sheet-head [data-lcg-sheet-close]');
        if (c) c.focus({ preventScroll: true });
      } else if (btn) btn.focus({ preventScroll: true });
    }

    root.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('[data-lcg-find]')) return;
      if (t.type === 'number') return apply(0);
      if (t.matches('input[type=checkbox], select')) apply(t.type === 'checkbox' ? 120 : 0);
    });
    root.addEventListener('input', (e) => { if (e.target.matches('[data-lcg-find]')) find(e.target); });
    root.addEventListener('submit', (e) => { e.preventDefault(); apply(0); });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-lcg-find]')) e.preventDefault();
    });
    root.addEventListener('click', (e) => {
      const t = e.target.closest('a, button, summary');
      if (!t || !root.contains(t)) return;
      if (t.matches('[data-lcg-link]')) { e.preventDefault(); return render(t.href); }
      if (t.matches('[data-lcg-next]')) { e.preventDefault(); return loadMore(t, e.detail === 0); }
      if (t.matches('[data-lcg-more]')) return setMore(!form().classList.contains('is-more'));
      if (t.matches('[data-lcg-sheet-open]')) return sheet(true);
      if (t.matches('[data-lcg-sheet-close]')) return sheet(false);
      if (t.matches('.lcg-preset')) {
        const pop = t.closest('.lcg-pop');
        const box = t.closest('[data-lcg-presets]');
        const pressed = t.getAttribute('aria-pressed') === 'true';
        pop.querySelector(`input[name="${box.dataset.minName}"]`).value = pressed ? '' : t.dataset.min;
        pop.querySelector(`input[name="${box.dataset.maxName}"]`).value = pressed ? '' : t.dataset.max;
        return apply(0);
      }
    });
    root.addEventListener('toggle', (e) => {
      const p = e.target;
      if (!p.matches || !p.matches('.lcg-pop') || !p.open) return;
      if (!phone.matches) closePops(p);
      align(p);
    }, true);
    root.addEventListener('click', (e) => {
      if (e.target.matches('.lcg-scrim')) sheet(false);
    });

    document.addEventListener('click', (e) => {
      if (phone.matches || root.contains(e.target) && e.target.closest('.lcg-pop')) return;
      closePops();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('is-sheet')) {
        const open = root.querySelector('.lcg-pop[open]');
        if (open && root.contains(document.activeElement) && open.contains(document.activeElement) && !phone.matches) { open.open = false; return; }
        return sheet(false);
      }
      const open = root.querySelector('.lcg-pop[open]');
      if (open) { open.open = false; open.querySelector('summary').focus(); }
    });
    phone.addEventListener('change', () => { if (!phone.matches && root.classList.contains('is-sheet')) sheet(false); closePops(); });
    window.addEventListener('popstate', () => render(location.href, false));

    hydrate();
  }

  const boot = () => document.querySelectorAll('[data-lcg]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
